import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "toggleable"]
  // 切り替えるclassはdata属性で指定
  static values = { visibleClass: { type: String, default: 'is-active' } }

  connect() {
    this.debouncedCheckVisibility = this.debounce(this.checkVisibility.bind(this), 100)
    window.addEventListener("scroll", this.debouncedCheckVisibility)
    this.checkVisibility()
  }

  disconnect() {
    window.removeEventListener("scroll", this.debouncedCheckVisibility)
  }

  checkVisibility() {
    if (!this.hasTriggerTarget || !this.hasToggleableTarget) {
      return
    }

    const triggerRect = this.triggerTarget.getBoundingClientRect()
    const windowHeight = window.innerHeight

    // 条件判定: trigger要素が画面内に表示
    const isTriggerVisible = triggerRect.top < windowHeight && triggerRect.bottom > 0

    if (isTriggerVisible) {
      this.toggleableTarget.classList.add(this.visibleClassValue)
    } else {
      this.toggleableTarget.classList.remove(this.visibleClassValue)
    }
  }

  debounce(func, wait) {
    let timeout
    return (...args) => {
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        func.apply(this, args)
      }, wait)
    }
  }
}